<template>
    <div class="purchase-fintos-report">
        <CreateNewCreditReportDrawer ref="drawer_create_new_credit_report" />
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Credit Reports</h2>
                </b-col>
                <!-- <b-col cols="6" class="text-right">
                    <b-button variant="primary" class="btn-header" @click="$refs.drawer_create_new_credit_report.viewDrawer()">Create New</b-button>
                </b-col> -->
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <CreditReportsTable ref="credit_report_table" />
        </b-container>
    </div>
</template>
<script>
import CreditReportsTable from '@/views/CreditReports/CreditReportsTable'
import CreateNewCreditReportDrawer from '@/views/CreditReports/CreateNewCreditReportDrawer'

export default {
    components: {
        CreditReportsTable,
        CreateNewCreditReportDrawer
    },
    data() {
        return {
            modals:{
                create_new_credit_report: false
            }
        };
    },
    methods: {
        refetchCreditReportList() {
            this.$refs.drawer_create_new_credit_report.viewDrawer()
            this.$refs.credit_report_table.getCreditReportsList()
        }
    }
}
</script>